import { session } from 'utils/storage';

import entities from 'services/entities';

import { api } from '../configs/axiosConfigs';

const FORM_PREFIX_URL = 'itau-jn6-app-contas-loja-api';

const proposal = {
  createLead: async function ({ stepName, payload }) {
    const handledPayload = entities.request.proposal({ stepName, payload });

    const response = await api.request({
      url: `${FORM_PREFIX_URL}/forms/`,
      method: 'POST',
      data: {
        'flow-name': 'flow-loja-contas-completo',
        'curr-step': stepName,
        data: handledPayload,
      },
      headers: {
        'G-Recaptcha-Response': payload?.recaptchaToken,
      },
    });

    const data = response?.data;
    const journeyID = data?.['journey-identifier'];

    session.setItem('journeyID', journeyID);

    return { data, error: response.error };
  },
  updateLead: async function ({ stepName, payload }) {
    const handledPayload = entities.request.proposal({ stepName, payload });

    const response = await api.request({
      url: `${FORM_PREFIX_URL}/forms/`,
      method: 'PATCH',
      data: {
        'flow-name': 'flow-loja-contas-completo',
        'curr-step': stepName,
        data: handledPayload,
      },
    });

    return { data: response?.data, error: response.error };
  },
  getLeadData: async function ({ stepName }) {
    const response = await api.request({
      url: `${FORM_PREFIX_URL}/forms/`,
      method: 'GET',
      headers: { FlowName: 'flow-loja-contas-completo', StepName: stepName },
    });

    return { data: response?.data, error: response.error };
  },
};

export default {
  ...proposal,
};
